import { createRouter, createWebHistory } from 'vue-router'
import { inject } from 'vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [{
            path: '/',
            component: () =>
                import ('@/views/home.vue')
        },
        {
            path: '/home',
            name: 'home',
            component: () =>
                import ('@/views/home.vue')
        },
        {
            path: '/detail/:id',
            name: 'detail',
            component: () =>
                import ('@/views/detail.vue')
        },
        {
            path: '/publish',
            name: 'publish',
            component: () =>
                import ('@/views/publish.vue'),
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/mybuy',
            name: 'mybuy',
            component: () =>
                import ('@/views/mybuy.vue'),
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/pay',
            name: 'pay',
            component: () =>
                import ('@/views/pay.vue'),
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/list',
            name: 'list',
            component: () =>
                import ('@/views/list.vue'),
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/mysale',
            name: 'mysale',
            component: () =>
                import ('@/views/mysale.vue'),
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('@/views/login.vue'),
        },
        {
            path: '/oidc-callback',
            name: 'oidc-callback',
            component: () =>
                import ('@/views/callback.vue'),
        },
    ],
})
router.beforeEach((to, from, next) => {
    const userManager = inject('userManager');
    var userAgent = navigator.userAgent;
    var IOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //修复IOS版微信分享H5 history兼容性问题
    if (IOS && to.path !== location.pathname) {
        // 此处不能用location.replace
        location.assign(to.fullPath)
    }
    if (to.meta.requireAuth) {
        localStorage.setItem('referrer', to.fullPath)
        userManager.getUser().then(function(user) {
            if (!user) {
                next({ path: '/login' })
            } else {
                // 判断token是否过期过期去登录
                var timestamp = Math.round(new Date().getTime() / 1000).toString();
                if (user.expires_at < timestamp) {
                    next({ path: '/login' })
                } else {
                    next()
                }
            }
        })
    } else {
        next();
    }
})

export default router